'use client';

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { Scope3Wizard } from '@/features/ghg/components/scope3-wizard';
import i18n from '@/lib/i18n';

const scope3AddSearchSchema = z.object({
  scope3Category: z.coerce.number().int().min(1).max(15).optional(),
  templateId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/ghg/scope3/add')({
  validateSearch: scope3AddSearchSchema,
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.addScope3Emissions'),
  }),
  component: Scope3AddPage,
});

function Scope3AddPage() {
  const search = Route.useSearch();

  return (
    <Scope3Wizard
      {...(search.scope3Category != null ? { initialScope3Category: search.scope3Category } : {})}
      {...(search.templateId ? { initialTemplateId: search.templateId } : {})}
    />
  );
}
